import { motion } from 'framer-motion'
import { type PropsWithChildren } from 'react'
import { cn } from '~/shared/lib/cn'
import { Text } from '~/shared/ui'

export function FieldsGroup({
  children,
  title,
  main,
}: PropsWithChildren<{ title?: string; main: boolean }>) {
  return (
    <motion.div
      layout
      className={cn('px-10', {
        'border-divider mx-4 rounded-lg border px-6 py-4': main,
      })}
    >
      {title && (
        <motion.div
          layout
          className="mb-4 flex items-center justify-between"
        >
          <Text appearance="SUBTITLE">{title}</Text>
        </motion.div>
      )}
      <motion.div layout>{children}</motion.div>
    </motion.div>
  )
}
